export default __webpack_public_path__ + "static/media/placeholder.d4240293.svg";